export default "__VITE_ASSET__03253235__"